import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { Form } from '@vfit/shared/components';
import { IUserIdentityField, IConfirmIdentity } from './confirmIdentity.model';
import { Container, Title, Description, DropDownContainer, Cta } from './confirmIdentity.style';

const ConfirmIdentity: React.FC<IConfirmIdentity> = ({ data, children }) => {
  const { register, setValue, getValues } = useForm<IUserIdentityField>({
    mode: 'all',
  });
  const { getSelectedData, identityTypeItems, title, description, placeholder } = data;

  const handlerData = useCallback(() => {
    const userIdentityType = getValues();
    getSelectedData(userIdentityType);
  }, [getSelectedData, getValues]);

  const onSelectItem = useCallback(
    (selectedValue: string) => {
      setValue('field', selectedValue);
      if (selectedValue.trim().length > 0) {
        if (selectedValue.includes('@')) {
          setValue('fieldType', 'email');
        } else {
          setValue('fieldType', 'msisdn');
        }
      }
      handlerData();
    },
    [handlerData, setValue]
  );

  return (
    <Container>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <DropDownContainer haveChildren={!!children}>
        <Form.SelectInput
          data-cs-mask=""
          inner-list-data-cs-mask="data-cs-mask"
          setValue={() => {
            onSelectItem('');
            return [];
          }}
          onSelectValue={(selectedValue) => {
            onSelectItem(selectedValue);
          }}
          label={placeholder}
          items={identityTypeItems}
          placeholder=" "
          {...register('field', {
            onChange: handlerData,
          })}
        />
        {data?.cta?.label && data?.cta?.url && (
          <Cta onClick={() => data?.cta?.action?.()}>{data.cta.label}</Cta>
        )}
      </DropDownContainer>
      {children && children}
    </Container>
  );
};
export default ConfirmIdentity;

